import { NextSeo } from 'next-seo'

import imgAbh from '@/assets/illustrations/abhimanyu.png'
import imgAru from '@/assets/illustrations/arun.png'
import imgRad from '@/assets/illustrations/radha.png'
import imgSom from '@/assets/illustrations/somaya.png'
import imgSum from '@/assets/illustrations/sumita.png'
import bottomImg from '@/assets/illustrations/teams.png'
import Button, { ButtonVariant } from '@/components/button'
import Link from '@/components/link'

const Team = () => {
  return (
    <div className='align-center  flex h-[100%] min-h-full  flex-wrap bg-theme-turquoise px-5'>
      <NextSeo title='Team' />
      <div className='py-custom pt-custom-150 mt-3 flex-[0_0_100%]'>
        <div className='mx-auto flex h-full max-w-[566px] flex-wrap content-between pl-9 pr-12'>
          <div className='flex-no-wrap mb-5 flex h-fit w-full items-center justify-between'>
            <div>
              <Link
                href='/about'
                className='custom-font-body !font-bold text-black'
              >
                ABOUT US
              </Link>
            </div>
            <div>
              <Link
                href='/our-usp'
                className='custom-font-body !font-bold text-black'
              >
                OUR USP
              </Link>
            </div>
            <div>
              <Button
                variant={ButtonVariant.Primary}
                bg='bg-[#F59175]'
                tailFill='#F59175'
                className='cm-bg custom-font-body !rounded-4xl !px-6 !py-2 !font-bold text-black'
                tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[41%] h-2'
              >
                <span className='translate-y-0.5'>Team</span>
              </Button>
            </div>
          </div>
          <div className='w-full pt-10'>
            <p className='custom-font-body'>
              <img
                src={`${imgSom.src}`}
                alt=''
                className='float-right w-[30%]'
              />
              <span className='font-semibold'>Soumya Rao, Founder</span>
              <br />
              Marketer and Innovator turned Mental Health Practitioner. Thrive
              Café was born out of her own search for emotional balance and
              liberation. She uses this understanding of the tools of therapy to
              create ‘Thrive Skills’ - an educational approach to positive
              emotional health.
            </p>
          </div>
          <div className='py-[7%]'>
            <div className='flex w-full'>
              <div>
                <img src={`${bottomImg.src}`} />
              </div>
              <div className='pt-1.5'>
                <a href='#founding-team'>
                  <Button
                    variant={ButtonVariant.Primary}
                    tailFill='#ffffff'
                    bg='bg-[#ffffff]'
                    className='explore !py-1'
                    tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[41%] h-2'
                  >
                    <span className='text-base font-semibold'>
                      FOUNDING TEAM
                    </span>
                  </Button>
                </a>
              </div>
            </div>
          </div>
          <div className='w-full pb-20' id='founding-team'>
            <div className='mb-5 flex'>
              <img
                src={`${imgSum.src}`}
                className='mr-5 w-[30%] object-contain object-top'
              />
              <p className='custom-font-body'>
                <span className='font-semibold'>
                  <span className='border-b border-black'>Dr Sumita Datta</span>
                  <br /> CURRICULUM & ASSESSMENTS
                </span>
                <br /> Senior Scholar with expertise in Teaching & Research in
                Leadership and Org Behaviour, Change & Development
              </p>
            </div>
            <div className='mb-5 flex'>
              <img
                src={`${imgAru.src}`}
                className='mr-5 w-[30%] object-contain object-top'
              />
              <p className='custom-font-body'>
                <span className='font-semibold'>
                  <span className='border-b border-black'>Arun Nambiar</span>
                  <br /> INSIGHTS & PLANNING
                </span>
                <br /> Ethnographer with 25 years of insight mining to deliver
                product design and content development
              </p>
            </div>
            <div className='mb-5 flex'>
              <img
                src={`${imgRad.src}`}
                className='mr-5 w-[30%] object-contain object-top'
              />
              <p className='custom-font-body'>
                <span className='font-semibold'>
                  <span className='border-b border-black'>Radha Rathi</span>
                </span>
                <br /> DESIGN & CONTENT
                <br /> Consultant with expertise in Visual branding and design
                Founder Radha Rathi Studio Co-founder Magic Bus Studio
              </p>
            </div>
            <div className='mb-5 flex'>
              <img
                src={`${imgAbh.src}`}
                className='mr-5 w-[30%] object-contain object-top'
              />
              <p className='custom-font-body'>
                <span className='font-semibold'>
                  <span className='border-b border-black'>
                    Abhimanyu Hingorani
                  </span>
                </span>
                <br /> OPERATIONS
                <br /> 8 years in Advertising
                <br /> 8 years in Marketing & Brand building - Retail &
                Hospitality
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Team
